//import JSShare from "js-share";
import * as Shareon from "shareon";


(function () {
    Shareon.init();
})();
